<template>
  <div class="sf-question-open">
    <label :for="inputId" class="visually-hidden">{{ question.prompt }}</label>
    <div class="sf-question-open__bar">
      <input
        :id="inputId"
        v-model="input"
        type="text"
        class="sf-question-open__input"
        :placeholder="placeholderText"
        @keydown.enter.prevent="send"
      />
      <button
        class="sf-question-open__send"
        :disabled="!input.trim()"
        aria-label="Verstuur antwoord"
        @click="send"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M2 10L18 10M18 10L12 4M18 10L12 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div v-if="question.show_random_button" class="sf-question-open__extras">
      <button class="sf-question-open__btn-alt" @click="chooseForMe">
        Jij mag kiezen
      </button>
    </div>
  </div>
</template>

<script>
let counter = 0;

export default {
  name: 'QuestionOpen',

  props: {
    question: { type: Object, required: true },
  },

  emits: ['answer'],

  data() {
    return {
      input: '',
      inputId: 'sf-open-' + (++counter),
    };
  },

  computed: {
    placeholderText() {
      return (this.question && this.question.placeholder) ? this.question.placeholder : 'Schrijf je bericht...';
    },
  },

  methods: {
    send() {
      const value = this.input.trim();
      if (!value) return;
      this.$emit('answer', {
        slot: this.question.slot || this.question.id,
        value,
        label: value,
      });
      this.input = '';
    },

    chooseForMe() {
      this.$emit('answer', {
        slot: this.question.slot || this.question.id,
        value: 'free_choice',
        label: 'Jij mag kiezen',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sf-question-open {
  padding: 8px 16px 16px;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;

  &__bar {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 29px;
    height: 58px;
    padding: 0 8px 0 20px;
    gap: 8px;
    border: 1.5px solid transparent;
    transition: border-color 0.2s;

    &:focus-within {
      border-color: #517b86;
    }
  }

  &__input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    font-family: 'Comfortaa', sans-serif;
    font-size: 16px;
    color: #23201e;

    &::placeholder {
      color: #b5afa5;
    }
  }

  &__send {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #23201e;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: opacity 0.2s;

    &:disabled {
      opacity: 0.4;
      cursor: default;
    }

    &:not(:disabled):hover {
      opacity: 0.85;
    }

    &:focus-visible {
      outline: 2px solid #517b86;
      outline-offset: 2px;
    }
  }

  &__extras {
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }

  &__btn-alt {
    background: #fff;
    border: 1.5px solid #23201e;
    color: #23201e;
    padding: 8px 20px;
    border-radius: 20px;
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #23201e;
      color: #fff;
    }
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
